'use client';
import { useRouter, useParams } from 'next/navigation';
import { useEffect, useMemo, useState } from 'react';
import { useI18n } from '@spot-fe/base-ui';
import {
  isApp,
  isBrowser,
  whiteListManager,
  loadJsHecateScript,
} from '@spot-fe/utils';

import Empty from '@/components/Empty';
// import ProjectCard from '@/components/ProjectCard';
import OnGoingProjectCard from '@/components/OnGoingProjectCard';
import EndProjectCard from '@/components/EndProjectCard';
import Faq from '@/components/Faq';
import { HomeHeader } from '@/components/Header';
import ProjectList, { defaultPaginationProps } from '@/components/ProjectList';
import { safeToFormat } from '@/utils/number';
import AppInfo from '@/components/AppInfo';
import { useList } from './store';
import { h5Jump, pcJump } from '@spot-fe/app-bridge';

import styles from './index.module.scss';
import ThemeProvider from '@/config/themeProvider';
import { Spin } from '@bfe/moly';
import { useData } from './data';
import { useIsMobile } from '@/hooks/useIsMobile';

export default function Index() {
  const store = useList();
  const { t } = useI18n();
  const router = useRouter();
  const params = useParams();

  const {
    isLoading,
    headLoading,
    init,
    total,
    endPagination,
    onGoingPaginationState,
  } = useData();
  // 响应页面尺寸变化
  const { isMobile } = useIsMobile();
  const isPc = !isMobile;
  const [appInfo, setAppInfo] = useState<any>({});
  const [client, setClient] = useState(false);
  const isOnGoingEmpty = !store.onGoingList || store.onGoingList.length === 0;
  const isEndEmpty = !store.endList || store.endList.length === 0;

  const headerAmount = {
    totalPrizePool: store.header?.totalPrizePool
      ? '$' + safeToFormat(store.header?.totalPrizePool, 0)
      : '--',
    averageBenefits: store.header?.averageBenefits
      ? '$' + safeToFormat(store.header?.averageBenefits, 2)
      : '--',
    projects: store.header?.projects
      ? safeToFormat(store.header?.projects, 0)
      : '--',
    participants: store.header?.participants
      ? safeToFormat(store.header?.participants, 0)
      : '--',
  };

  const onGoingProps = {
    total: onGoingPaginationState.total,
    pageSize: onGoingPaginationState.pageSize,
    current: onGoingPaginationState.current,
    onChange: (params) => {
      onGoingPaginationState.setPage(params?.current);
    },
  };
  const onGoingList = (store.onGoingList || []).slice(
    onGoingPaginationState.start,
    onGoingPaginationState.end
  );

  const endProps = {
    total: endPagination.total,
    pageSize: endPagination.pageSize,
    current: endPagination.current,
    onChange: (params) => {
      console.log('endProps onChange:', params);
      endPagination.setPage(params.current);
    },
  };

  const endList = store.endList;

  const getProdDomain = () => {
    const hostname = window.location.hostname || '';
    const protocol = window.location.protocol || '';
    const originHost = 'www.bybit.com';
    const isTestnet = hostname.includes('testnet');
    const isProd = !hostname.includes('test');
    if (isTestnet || isProd) {
      const parts = hostname.split('.');
      const prodDomain = parts.join('.');
      return `${protocol}//${prodDomain}`;
    }

    return `${protocol}//${originHost}`;
  };

  const lang = params.lang;

  const navToDetail = ({ code }) => {
    if (!code) {
      return;
    }
    router.push(`/${lang}/trade/spot/token-splash/detail?code=${code}`);
  };

  useEffect(() => {
    const getApps = async () => {
      await loadJsHecateScript();
      try {
        (window as any)?.BybitHecate.module('SystemInfo')
          .method('getAppConfig')
          .invoke({})
          .then((res) => {
            if (res?.code === 0) {
              const o = (res?.params?.platform || '').toLowerCase();
              const v = res?.params?.osVersion || '';
              const s = v.split('.');
              setAppInfo({
                o,
                s: s[0],
              });
            }
          });
      } catch (e) {
        console.error(e);
      }
    };
    if (isApp()) {
      getApps();
    }
  }, []);

  const isRenderAppTips = useMemo(() => {
    if (!Reflect.ownKeys(appInfo).length) return false;
    const os = appInfo.o;
    const version = +appInfo.s;
    if ((os === 'ios' && version < 13) || (os === 'android' && version < 6)) {
      return true;
    }
    return false;
  }, [appInfo]);

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      window['RegulatedSiteHosts'] === 'BYBIT'
    ) {
      setClient(true);
    }
  }, []);

  const clientItems = [
    {
      keyword: t('totalPrizePool') + '(USD)',
      amount: headerAmount.totalPrizePool,
    },
    {
      keyword: t('avgBenefits') + '(USD)',
      amount: headerAmount.averageBenefits,
    },
    { keyword: t('projects'), amount: headerAmount.projects },
    {
      keyword: t('participants'),
      amount: headerAmount.participants,
    },
  ];
  return (
    <>
      {isRenderAppTips ? (
        <AppInfo platform={appInfo?.o} />
      ) : (
        <ThemeProvider>
          <div className={styles.depositEarn}>
            <HomeHeader
              // showTotal={whiteListManager.isMainSite()}
              isPc={isPc}
              title={t('mainTitle')}
              subTitle={t('tokenSplashSubTitle')}
              items={client ? clientItems : []}
            />
            {store.activityLoading && (
              <div className={styles.emptyBox}>
                <Spin />
              </div>
            )}
            {isOnGoingEmpty && isEndEmpty && !isLoading ? (
              <Empty
                text={t('noData')}
                onRefresh={() => {
                  init();
                  // store.fetchData(defaultPaginationProps);
                }}
              />
            ) : null}
            {/* 进行中的项目 */}
            {onGoingList?.length > 0 && (
              <ProjectList
                title={t('allProjects')}
                subTitle={t('tokenSplashSubTitle')}
                pagination={onGoingProps}
                isPc={isPc}
                noFooter={!onGoingPaginationState.display}
                noFooterPadding
              >
                {onGoingList.map((item) => {
                  return (
                    <OnGoingProjectCard
                      isPc={isPc}
                      key={item.code}
                      project={item}
                      onAction={navToDetail}
                    />
                  );
                })}
              </ProjectList>
            )}

            {/* 历史项目 */}
            {endList?.length > 0 &&
              !store.activityLoading &&
              endList?.length > 0 && (
                <ProjectList
                  title={t('pastEvents')}
                  subTitle={t('regTaskEnd')}
                  pagination={endProps}
                  isPc={isPc}
                  isHistory
                  noFooterPadding
                  noHeaderPadding
                >
                  {(endList || []).map((item) => {
                    return (
                      <EndProjectCard
                        isPc={isPc}
                        key={item.code}
                        project={item}
                        onAction={navToDetail}
                      />
                    );
                  })}
                </ProjectList>
              )}
            {!store.activityLoading && !store.historyLoading && (
              <Faq
                title={t('faq')}
                action={t('helpCenter')}
                onAction={() => {
                  const url = `${getProdDomain()}/${lang}/help-center/s/article/FAQ-Token-Splash`;
                  if (isApp()) {
                    h5Jump(`bybitapp://open/web?url=${url}`);
                    return;
                  }
                  pcJump(url);
                }}
              />
            )}
          </div>
        </ThemeProvider>
      )}
    </>
  );
}
